import http from '@/utils/services/http'

export default {
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/impedimentos/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findSimple (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/impedimentos/' + id + '/simple')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  lista (limit, page, filtros) {
    let url = '/api/impedimentos?page=' + page + '&limit=' + limit + filtros
    console.log(url)
    return http.get(url) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  cobrar (id) {
    let url = '/api/impedimentos/' + id + '/enviarCobranca'
    console.log(url)
    return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/impedimentos/services/index.js